/* eslint-disable no-new */
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

class SectionSlider {
	constructor(section) {
		this.wrapper = section;
		this.slider = this.wrapper.querySelector('.slider');
		this.content = this.wrapper.querySelector('.main__slider-content');
		this.btnPrev = this.wrapper.querySelector('.swiper-button-prev');
		this.btnNext = this.wrapper.querySelector('.swiper-button-next');
		this.pagination = this.wrapper.querySelector('.swiper-pagination');
		this.btnShowMOre = this.wrapper.querySelector('.main__slider-show-more');
		this.allSlides = this.slider.getElementsByClassName('swiper-slide');
		this.innerPage = document.querySelector('.contents-page');
		this.numberShowMore = 3;
		this.params = {
			direction: 'horizontal',
			spaceBetween: this.innerPage ? 20 : 30,
			slidesPerView: 'auto',
			slidesPerGroup: 3,
			// pagination: {
			// 	el: this.pagination,
			// 	type: 'custom',
			// 	renderCustom(swiper, current, total) {
			// 		return `<span>${current}</span><span class="splitter"></span><span>${total}</span>`;
			// 	},
			// },
			navigation: {
				nextEl: this.btnNext,
				prevEl: this.btnPrev,
			},
		};
		this.btnShowMOre.onclick = this.showMore.bind(this);
		this.init();
	}

	hideContent(slider) {
		if (slider.activeIndex > 0 && this.content) {
			this.content.style.opacity = 0;
		} else if (this.content) {
			this.content.style.opacity = 1;
		}
	}

	setPagination() {
		const allSlidelength = this.slider.querySelectorAll('.swiper-slide').length;
		const value = allSlidelength / 10 < 1 ? `0${allSlidelength}` : allSlidelength;
		this.pagination.innerHTML = `<span>01</span><span class="splitter"></span><span>${value}</span>`;
	}

	// eslint-disable-next-line
	update(slider) {
		if (window.innerWidth < 768) {
			slider.slideTo(0);
			slider.disable();
		} else {
			slider.enable();
		}
	}

	init() {
		this.setPagination();
		const slider = new Swiper(this.slider, this.params);

		// eslint-disable-next-line
		slider.on('slideChange', (slider) => {
			this.hideContent(slider);
		});

		window.addEventListener('resize', () => {
			this.update(slider);
		});

		this.update(slider);
	}

	showMore() {
		let counter = 1;

		for (let i = 0; i < this.allSlides.length; i++) {
			if (getComputedStyle(this.allSlides[i]).display === 'none') {
				this.allSlides[i].style.display = 'block';
				counter++;

				if (i + 1 === this.allSlides.length) {
					this.btnShowMOre.style.display = 'none';
				}

				if (counter > this.numberShowMore) {
					break;
				}
			}
		}
	}
}

function init() {
	const allSectionSkiders = document.querySelectorAll('.slider-section');

	allSectionSkiders.forEach((el) => {
		new SectionSlider(el);
	});
}

export default {
	init,
};
